package link.erpango.quip.data.db.entities

import link.erpango.quip.db.QuipDb
import link.erpango.quip.domain.entities.DCommonValue
import linkerpangoquipdb.Common_values
import app.cash.sqldelight.async.coroutines.awaitAsOneOrNull
import app.cash.sqldelight.async.coroutines.awaitAsList

class CommonValuesDAO(val db: QuipDb): ICommonValuesTable {
    override suspend fun insertValue(id: String, value: String, updatedAt: Long) {
        if (selectValue(id) != null) {
            updateValue(id, value, updatedAt)
        } else {
            db.commonValuesQueries.insertValue(id, value, updatedAt)
        }
    }

    override suspend fun selectValue(id: String): String? {
        return db.commonValuesQueries.selectValue(id).awaitAsOneOrNull()
    }

    override suspend fun selectCompleteValue(id: String): DCommonValue? {
        return db.commonValuesQueries.selectCompleteValue(id).awaitAsOneOrNull()?.let {
            CommonValueDbAdapter.commonValueFromDb(it)
        }
    }

    override suspend fun selectAllValues(): List<DCommonValue> {
        return db.commonValuesQueries.selectAllValues().awaitAsList().map {
            CommonValueDbAdapter.commonValueFromDb(it)
        }
    }

    override suspend fun deleteValue(id: String) {
        db.commonValuesQueries.deleteValue(id)
    }

    override suspend fun deleteAllValues() {
        db.commonValuesQueries.deleteAllValues()
    }

    override suspend fun updateValue(id: String, value: String, updatedAt: Long) {
        db.commonValuesQueries.updateValue(value, updatedAt, id)
    }
}

object CommonValueDbAdapter {
    fun commonValueFromDb(dbValue: Common_values): DCommonValue {
        return DCommonValue(
            id = dbValue.id,
            value = dbValue.value_,
            updatedAt = dbValue.last_update
        )
    }
}